<template>
    <v-container class="fill-height pa-0" fluid v-if="!loading">
        <v-card
        :class="[conversationsList ? 'panel-push-left' : '', conversationDetail ? 'panel-push-right' : '' ]"
        class="fill-height flex-grow-1 conversation-card" 
        flat
        tile
        >  

        <v-overlay
            absolute
            class="conversation-overlay"
            v-if="this.currentChattRecepientrPhoneList.length >= 1 || this.BussinessPhones.length >= 1"
            :value="overlay"
            opacity="0.95"
        >
            <v-container>
                <div v-if="this.currentChattRecepientrPhoneList.length < 1"> 
                    <v-row>
                        <v-col cols="12">
                            <v-card max-width="550" elevation="3">
                                <v-card-title>
                                    <v-img  
                                        class="mb-5"
                                        transition="scale-transition"
                                        contain
                                        max-height="200px"
                                        src="../assets/images/logo-white.png">
                                    </v-img>
                                </v-card-title>
                                <v-card-text class="text-center">
                                    <p>
                                        Unfortunately, none of the contacts associated here have a phone number we can message.
                                        <br> Please add a valid phone or mobile phone number to a contact.
                                    </p> 
  
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
                <div v-else>
                <v-row>
                    <v-col cols="12">
                    <v-card max-width="450" elevation="3">
                        <v-card-title>
                            <v-img  
                            class="mb-5"
                            transition="scale-transition"
                            contain
                            max-height="100px"
                            src="../assets/images/logo-white.png">
                            </v-img>
                        </v-card-title>
                        <v-card-text>
                            <!-- chat with --> 

                            <div class="my-6" v-if="BussinessPhones.length === 1"> 
                                <label>Conversation will use this Business phone</label>
                                <v-list-item dense two-line  class="flex-compact">
                                    <v-list-item-content>
                                        <v-list-item-title>{{BussinessPhones[0].alias}}</v-list-item-title>
                                        <v-list-item-subtitle> {{ BussinessPhones[0].phone}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </div>
                            <div class="my-6" v-else>
                                <label>Please set your business Number/Role for this chat</label>
                                <v-select
                                    class="conversation-phone " 
                                    style="flex: 0 1 auto;"
                                    prepend-inner-icon="mdi-phone"
                                    v-model="BussinessPhoneSelected"
                                    @change="setBussinessPhoneSelected"
                                    :items="BussinessPhones"
                                    item-text="alias"
                                    item-value="phone"
                                    label="Business Role/Phone"
                                    hide-details
                                    solo
                                    return-object
                                    :menu-props="{ top: false, offsetY: true }"
                                >
                                    <template v-slot:selection="{ item, phoneIndex}">
                                        <v-list-item  two-line class="px-1 selected-item">                                
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    {{ item.alias }}
                                                </v-list-item-title>
                                                <v-list-item-subtitle>
                                                    {{item.phone}}
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                    <template v-slot:item="{ active, item, attrs, on }">
                                        <v-list-item  :input-value="active" dense v-on="on" v-bind="attrs" :default="{ active }">
                                            <v-list-item-content>
                                                <v-row class="d-flex flex-nowrap" align="center" no-gutters>
                                                    <span class="pr-2">{{ item.alias }} </span>
                                                    <v-spacer></v-spacer>
                                                    <v-chip v-if="item.phone" text-color="white" color="secondary" small>
                                                        {{ item.phone }}
                                                    </v-chip>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </v-select>
                            </div>
                            <div class="my-6" v-if="currentChattRecepientrPhoneList.length === 1">
                                <label>You're about to  start a conversation with </label>
                                <v-list-item dense two-line class="conversation-recepient pl-0 mr-auto" style="flex: 0 1 auto;" >
                                        <v-list-item-avatar class="my-0 mr-1">
                                                    <v-avatar
                                                        :size="!this.$vuetify.breakpoint.smAndDown ? '50' : ''"
                                                        class="font-weight-bold text-h5 "
                                                    >
                                                    {{getConversationInitials(currentChattRecepientrPhoneList[0].fullName)}}
                                                    </v-avatar>
                                        </v-list-item-avatar>
                                        <v-list-item-content class="d-inline-flex">
                                            <v-list-item-title class="font-weight-medium">{{currentChattRecepientrPhoneList[0].fullName}}</v-list-item-title>
                                            <v-list-item-subtitle class=""> {{currentChattRecepientrPhoneList[0].phone}} </v-list-item-subtitle>
                                        </v-list-item-content>
                                </v-list-item>
                            </div>
                            <div  class="my-6" v-else>
                                <label>Before we start, please select the contact number for this conversation</label>
                                <v-select
                                    class="conversation-phone "
                                    style="flex: 0 1 auto;"
                                    prepend-inner-icon="mdi-phone"
                                    v-model="ContactPhoneSelected"
                                    @change="setContactPhoneSelected"
                                    :items="currentChattRecepientrPhoneList"
                                    item-text="alias"
                                    item-value="alias"
                                    label="User Contact Phone"
                                    hide-details
                                    solo
                                    return-object
                                    :menu-props="{ top: false, offsetY: true }"
                                >
                                    <template v-slot:selection="{item, userPhoneIndex}">
                                        <v-list-item two-line class="px-1 selected-item">
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    {{item.alias}}
                                                </v-list-item-title>
                                                <v-list-item-subtitle>
                                                    {{item.phone}}
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                    <template v-slot:item="{active, item, attrs, on}">
                                        <v-list-item :input-value="active" dense v-on="on" v-bind="attrs" :default="{active}">
                                            <v-list-item-content>
                                                <v-row class="d-flex flex-nowrap" align="center" no-gutters>
                                                    <span class="pr-2">{{ item.alias }}</span>
                                                    <v-spacer></v-spacer>
                                                    <v-chip v-if="item.phone" text-color="white" color="secondary" small>
                                                        {{ item.phone}}
                                                    </v-chip>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </v-select>
                            </div>
                        </v-card-text>  
                        <v-card-actions class="d-flex justify-center">
                            <v-btn
                                color="primary"
                                @click="loadMessages()"> 
                                Continue 
                            </v-btn>
                        </v-card-actions>
                        
                    </v-card>
                    </v-col>
                </v-row>
                </div>
            </v-container>
          
        </v-overlay>
        
            <div class="conversation">
                <ConversationToolbar 
                :isMultiChat="this.isMultiChat"
                :conversationsList="this.conversationsList"
                :conversationDetail="this.conversationDetail"
                :currentUser="this.currentUser"
                :isFavorite="this.isFavorite"
                @setFavorite = "setFavorite"
                :currentChatInfo="this.currentChatInfo"
                :currentChattRecepientrPhoneList ="this.currentChattRecepientrPhoneList"
                :BussinessPhoneSelected="this.BussinessPhoneSelected"
                :BussinessPhones="this.BussinessPhones"
                @setConvesationListVisibility ="setConvesationListVisibility"
                @setConversationDetailVisibility ="setConversationDetailVisibility"
                @setBussinessPhoneSelected ="setBussinessPhoneSelected"
                @setContactPhoneSelected="setContactPhoneSelected" 
                ></ConversationToolbar>

                <ConversationBody
                :isMultiChat="this.isMultiChat"
                :appBarHeight="0"
                :currentUser="this.currentUser"
                :currentChatInfo="this.currentChatInfo"
                :chatEntries="this.chatEntries"
                @setFavorite = "setFavorite"
                :conversationsList="this.conversationsList"
                :conversationDetail="this.conversationDetail"
                :isConversation="this.isConversation"
                :isFavorite="this.isFavorite"
                :unsubscribed="this.unsubscribed"
                :BussinessPhones="this.BussinessPhones"
                ></ConversationBody>
                
            </div>

        </v-card>
        <v-navigation-drawer class="user-info-nav"
            v-model="conversationDetail"
            absolute
            right
            mobile-breakpoint="xs"
            width="250"
        >
            <v-toolbar-title class="d-flex align-center justify-space-between py-1 px-3">
                User Information
                <v-btn icon @click="conversationDetail = !conversationDetail">
                    <v-icon>mdi-window-close</v-icon>
                </v-btn>    
            </v-toolbar-title>
            <v-divider></v-divider>
            <v-container class="d-flex flex-column">
                <v-row class="my-auto flex-grow-1">
                    <v-col cols="12" >
                        <v-list-item class="d-flex flex-column">
                                <v-list-item-avatar color="iq_lightblue" elevation="5" class="ma-0 bordered text-h4" size="62">
                                   {{currentChatInfo.initials}}
                                </v-list-item-avatar>
                                <v-list-item-content class="text-center ma-0">
                                     <v-list-item-title>{{currentChatInfo.firstName}} {{currentChatInfo.lastName}}</v-list-item-title>
                                    <v-list-item-title>{{formatPhoneNumber(currentChatInfo.phone)}}</v-list-item-title>
                                </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-text-field v-model="currentChatInfo.firstName"
                            label="First Name"
                        ></v-text-field>
                        <v-text-field v-model="currentChatInfo.lastName"
                            label="Last Name"
                        ></v-text-field>
                        <v-text-field :value="formatPhoneNumber(currentChatInfo.phone)"
                            label="Phone Number"
                            readonly
                            disabled
                        ></v-text-field>
                        <v-text-field v-model="currentChatInfo.email"
                            label="Email"
                        ></v-text-field>
                        <v-row >
                            <v-col class="d-flex justify-space-between">
                                <v-btn tex color="primary" outlinedt>
                                    Close
                                </v-btn>
                                <v-btn color="primary" @click="updateCurrentChatInfo">
                                    Save Changes
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
               
           </v-container>
           <template v-slot:append>
               <v-col>
                    <v-btn rounded block color="warning darken-1" @click="getHubspotURL"> 
                        View Hubspot Contact
                    </v-btn>
                </v-col>
           </template>
        </v-navigation-drawer>
        <v-snackbar 
            v-for="(message, idx) in messageEntryList" :key="idx" 
            :style="{'margin-bottom':calcMargin(idx)}"
            v-model="snackbar"
            :timeout="timeout"
            >
            <div>{{ message.msg }}</div>
            <span class="caption">{{ message.phone }}</span>

            <template v-slot:action="{ attrs }">
                <v-btn
                color="blue"
                text
                v-bind="attrs"
                @click="snackbar = false"
                >
                Close
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
    
</template>
<script>

// vendor components
import ConversationToolbar from '../components/shared/_conversationToolbar.vue';
import ConversationBody from '../components/shared/_conversationBody.vue';
import { mapGetters } from 'vuex';
import messageHub from '../messageHub';
import moment from "moment";
export default {
   components: {
        ConversationToolbar,
        ConversationBody
    },
    data () {
      return {
        //snackbar demo purpose only, TODO: needs enhancement 
        newMessage: false, //this is watch for changes 
        messageEntryList: [
            {phone: '(305) 800 2533', msg: 'Hi, good day, I would like info'},
            {phone: '(305) 800 2500', msg: 'Hi, good morning, I would like info'},
            {phone: '(305) 800 3000', msg: 'Hi, good night, I would like info'}
        ],
        snackbar: false,
        timeout: 5000,

        //layout
        isMultiChat: false,
        conversationsList: false,
        conversationDetail: false,
        selectedConversation: null,
        desktopConversationsWidth: "250px",
        //HS user multi phone contact 
        overlay: true,

        //check for resize 
        window: {
            width: 0,
            height: 0
        },
        //data generated randomly for demo  
        colors: ['#2196F3', '#90CAF9', '#64B5F6', '#42A5F5', '#1E88E5', '#1976D2', '#1565C0', '#0D47A1', '#82B1FF', '#448AFF', '#2979FF', '#2962FF'],
        names: ['Oliver', 'Jake', 'Noah', 'James', 'Jack', 'Connor', 'Liam', 'John', 'Harry', 'Callum', 'Mason', 'Robert', 'Jacob', 'Jacob', 'Jacob', 'Michael', 'Charlie', 'Kyle', 'William', 'William', 'Thomas', 'Joe', 'Ethan', 'David', 'George', 'Reece', 'Michael', 'Richard', 'Oscar', 'Rhys', 'Alexander', 'Joseph', 'James', 'Charlie', 'James', 'Charles', 'William', 'Damian', 'Daniel', 'Thomas', 'Amelia', 'Margaret', 'Emma', 'Mary', 'Olivia', 'Samantha', 'Olivia', 'Patricia', 'Isla', 'Bethany'],
        surnames: ['Smith', 'Anderson', 'Clark', 'Wright', 'Mitchell', 'Johnson', 'Thomas', 'Rodriguez', 'Lopez', 'Perez', 'Williams', 'Jackson', 'Lewis', 'Hill', 'Roberts', 'Jones', 'White', 'Lee', 'Scott', 'Turner', 'Brown', 'Harris', 'Walker', 'Green', 'Phillips', 'Davis', 'Martin', 'Hall', 'Adams', 'Campbell', 'Miller', 'Thompson', 'Allen', 'Baker', 'Parker', 'Wilson', 'Garcia', 'Young', 'Gonzalez', 'Evans', 'Moore', 'Martinez', 'Hernandez', 'Nelson', 'Edwards', 'Taylor', 'Robinson', 'King', 'Carter', 'Collins'],
        messages: ['what´s the dizzle?','what´s poppin´?','yello','what´s the rumpus?','what´s cracking?','what´s cracking?','good morning','yello','good evening','what´s poppin´?','sup','how´s it going?','wussup?','what´s the dilly?','what´s the rumpus?','what´s crack-a-lackin´?','good afternoon','how goes it?','greetings','´sup?','good day','good night','yello','salutations','what´s shaking?','good afternoon','holla','what´s happening?','What´s in the bag?','´sup, b?','´sup, b?','yo','whazzup?','what´s happening?','what´s the haps?','good night','whazzup?','hello','what´s the dizzle?','holla','good day','how ya goin?','what´s up?','how goes it?','ahoy','what´s cooking?','how goes it?','what´s cracking?','aloha','how´s it going?','what´s crack-a-lackin´?','aloha','what´s shaking?','what up?','what´s the dilly?','what´s up?','hello','greetings','good night','good afternoon','how´s it hanging?','aloha','what´s the dilly?','howzit?','holla','guten Tag','how´s it going?','what´s shaking?','wassap?','what´s up?','howzit?','good afternoon','wussup?','hola','how goes it?','ahoy','holla','howzit?','hola','how do?','what´s the rumpus?','how´s it going?','what´s happening?','yello','what´s cracking?','what ho?','what´s the dilly?','good afternoon','how´s it hanging?','what´s crack-a-lackin´?','what´s new?','good afternoon','what´s crackin´?','´sup, b?','how´s it hanging?','What´s in the bag?','good morning','good night','how do?','what´s new?','hey','What´s in the bag?','konnichi wa','wassap?','what´s cracking?','hola','what´s cooking?','hello','what´s the dizzle?','´sup, b?','what´s happening?','what´s the dizzle?','konnichi wa','´sup, b?','´sup, b?','what up?','good afternoon','what´s poppin´?','how goes it?','good morning','ahoy','good morning','aloha','howzit?','what´s crack-a-lackin´?','howzit?','good night','holla','konnichi wa','what´s cooking?','how ya goin?','konnichi wa','how´s it hanging?','what up?','´sup?','what´s poppin´?','how´s it hanging?','how do?','good evening','what ho?','how´s it hanging?','what ho?','ahoy','what´s crack-a-lackin´?','yello','guten Tag','good evening','wussup?','what´s happening?','good evening','what up?','yo','yo','wussup?','what´s cracking?','what´s new?','hey','ahoy','what up?','what´s cooking?','what´s the dizzle?','´sup, b?','konnichi wa','sup','what up?','what´s happening?','how ya goin?','holla','good afternoon','salutations','what´s new?','aloha','how´s it going?','what´s new?','what´s up?','how´s it hanging?','yello','good day','what´s crackin´?','what´s crack-a-lackin´?','what´s the haps?','´sup, b?','what ho?','whazzup?','good morning','konnichi wa','what´s happening?','how´s it hanging?','salutations','what up?','what up?','howsyamomanem?','how´s it going?','wussup?','how ya goin?','good morning','what´s poppin´?','wussup?','guten Tag','howzit?','ahoy','what´s shaking?','what´s happening?','´sup?','how´s it going?','howsyamomanem?','what´s shaking?','hey','what´s cracking?','salutations','good day','´sup?','what ho?','how´s it going?','how ya goin?','what´s cooking?','guten Tag','good day','how´s it going?','how ya goin?','what´s cooking?','yo','what´s crack-a-lackin´?','what up?','good afternoon','sup','´sup, b?','yello','wassap?','how´s it hanging?','how do?','what´s cracking?','whazzup?','whazzup?','yo','good afternoon','what´s new?','yo','what ho?','what´s happening?','greetings','yello','what´s the dizzle?','what´s new?','´sup?','´sup?','what´s the haps?','how´s it going?','what ho?','what´s cracking?','konnichi wa','good afternoon','good afternoon','good morning','how´s it hanging?','´sup?','hola','what´s cooking?','how´s it hanging?','aloha','what ho?','wassap?','hey','What´s in the bag?','good evening','what´s new?','what´s shaking?','aloha','what ho?','What´s in the bag?','What´s in the bag?','how´s it hanging?','what´s up?','how goes it?','how´s it going?','what´s up?','how´s it hanging?','holla','What´s in the bag?','hey','what´s new?','what´s poppin´?','´sup, b?','wussup?','what´s the dizzle?','what´s up?','wussup?','what´s the dizzle?','how goes it?','what ho?','what up?','wussup?','howzit?','good night','aloha','wussup?','what´s cracking?','hello','what´s new?','what ho?','konnichi wa','what´s crack-a-lackin´?','what´s cracking?','good day','salutations','what´s cooking?','hello','what´s cooking?','yo','salutations','what´s crackin´?','salutations','guten Tag','greetings','´sup, b?','what´s cooking?','salutations','what´s shaking?','what´s the haps?','how´s it going?','what´s the dilly?','what´s the dizzle?','what´s crack-a-lackin´?','hola','what´s the dilly?','konnichi wa','what´s up?','how do?','what´s the dizzle?','what´s the dilly?','what´s cooking?','good afternoon','how goes it?','yo','how do?','ahoy','yello','holla','ahoy','what´s the dizzle?','what´s crack-a-lackin´?','what ho?','wussup?','wassap?','greetings','what´s up?','what ho?','what´s the dizzle?','greetings','how ya goin?','yello','good day','what ho?','what´s cooking?','what´s new?','what´s crack-a-lackin´?','what´s the rumpus?','good morning','What´s in the bag?','aloha','how´s it going?','good afternoon','sup','what´s cooking?','´sup, b?','how´s it going?','What´s in the bag?','what´s poppin´?','what´s crack-a-lackin´?','what´s cracking?','good day','what´s the rumpus?','what´s the rumpus?','whazzup?','what´s cooking?','how´s it hanging?','what´s cracking?','konnichi wa','hola','howzit?','whazzup?','good morning','good afternoon','how goes it?','yo','wassap?','yello','good night','good morning','how ya goin?','sup','how do?','what´s poppin´?','what´s cracking?','aloha','what´s poppin´?','what´s crack-a-lackin´?','hola','what´s the dilly?','What´s in the bag?','what´s crack-a-lackin´?','what up?','what´s crackin´?','what´s new?','what´s up?','what´s crack-a-lackin´?','hola','how´s it hanging?','how´s it hanging?','´sup?','how´s it going?','wussup?','how goes it?','what´s the haps?','what´s up?','what´s shaking?','what´s the dizzle?','how goes it?','what´s the dizzle?','what´s poppin´?','what´s crackin´?','sup','guten Tag','what´s poppin´?','wassap?','greetings','what´s the dizzle?','hola','aloha','what´s new?','holla','good morning','howsyamomanem?','what´s crack-a-lackin´?','what´s happening?','how´s it hanging?','good morning','what´s the dizzle?','what´s the dizzle?','yo','good evening','how´s it going?','what´s cooking?','good night','wussup?','what´s crack-a-lackin´?','hey','how ya goin?','konnichi wa','good morning','wassap?','what´s new?','what ho?','what ho?','what´s the dilly?','wussup?','good day','what´s happening?','hola','what´s shaking?','konnichi wa','What´s in the bag?','´sup, b?','salutations','what´s poppin´?','what´s shaking?','aloha','wassap?','wussup?','aloha','good afternoon','hello','yo','what´s poppin´?','how ya goin?','guten Tag','good night','´sup, b?','yello','what´s happening?','what´s cracking?','´sup, b?','what´s cooking?','what´s the haps?','what´s the dizzle?','guten Tag','good morning','how ya goin?','how´s it going?','konnichi wa','´sup, b?','wassap?','good night','wassap?','good evening','hola','what´s the dizzle?','what´s up?','how do?','what´s the dilly?','how´s it hanging?','how do?','wassap?','what´s cooking?','sup','good afternoon','what´s cooking?','what´s cooking?','salutations','sup','yello','salutations','what´s shaking?','good morning','what´s new?','konnichi wa','good day','what´s happening?','what´s the dizzle?','sup','hey','hello','how goes it?','greetings','whazzup?','good afternoon','aloha','what up?','ahoy','what´s new?','how do?','how´s it hanging?','What´s in the bag?','what´s the dilly?','greetings','howzit?','good afternoon','wassap?','hola','howzit?','what´s crackin´?','good day','´sup, b?','whazzup?','how´s it hanging?','yo','what´s the haps?','sup','what ho?','guten Tag','what´s shaking?','sup','what´s new?','whazzup?','how goes it?','sup','howzit?','holla','what´s the dizzle?','how´s it hanging?','ahoy','good day','whazzup?','what´s poppin´?','yello','holla','how ya goin?','yello','howzit?','how ya goin?','howsyamomanem?','what´s the dizzle?','what´s new?','what´s the dizzle?','What´s in the bag?','good day','what´s the dilly?','´sup?','what´s crackin´?','what´s crackin´?','guten Tag','what´s cracking?','how´s it hanging?','what´s cracking?','howzit?','what´s the dizzle?','what´s up?','hello','good day','hola','how´s it going?','guten Tag','what´s the rumpus?','what´s poppin´?','what ho?','yo','what´s the rumpus?','how´s it going?','how´s it going?','ahoy','whazzup?','what´s the dizzle?','what´s crack-a-lackin´?','wussup?','wassap?','hey','´sup?','salutations','what´s cooking?','how do?','wassap?','what´s happening?','howzit?','how´s it going?','What´s in the bag?','howsyamomanem?','wassap?','good day','good evening','salutations','good day','how´s it going?','what´s the dilly?','salutations','what ho?','hello','howzit?','konnichi wa','how´s it going?','what´s cooking?','what´s crackin´?','sup','What´s in the bag?','hello','how´s it going?','whazzup?','´sup, b?','good night','what´s the dilly?','what´s new?','what´s poppin´?','howsyamomanem?','good day','wassap?','greetings','what´s the dizzle?','what´s happening?','what´s crackin´?','What´s in the bag?','what´s the dizzle?','konnichi wa','What´s in the bag?','what´s cracking?','what´s happening?','how´s it hanging?','salutations','what´s new?','how do?','greetings','how´s it hanging?','hello','sup','good morning','what´s the dizzle?','hey','what´s cracking?','what ho?','wassap?','how´s it going?','what´s up?','what´s crackin´?','what´s the haps?','how´s it hanging?','how goes it?','´sup, b?','what´s the dizzle?','hola','what´s the rumpus?','konnichi wa','how´s it hanging?','good night','hey','whazzup?','sup','good morning','what´s crackin´?','what ho?','good evening','yo','how do?','what´s the dilly?','what´s the haps?','greetings','guten Tag','yello','What´s in the bag?','how goes it?','what´s cracking?','wussup?','how´s it hanging?','what´s crack-a-lackin´?','good night','how goes it?','how do?','how´s it going?','yello','how´s it going?','what´s the haps?','hey','how goes it?','good morning','konnichi wa','howzit?','what´s crack-a-lackin´?','good morning','what´s crack-a-lackin´?','greetings','what´s cracking?','how´s it going?','What´s in the bag?','how´s it going?','what´s happening?','good evening','´sup, b?','wussup?','good day','wassap?','aloha','what up?','salutations','how goes it?','how do?','´sup?','whazzup?','good night','what´s shaking?','hola','greetings','good afternoon','what´s the dilly?','what´s happening?','konnichi wa','what ho?','what´s cracking?','hey','how´s it going?','good evening','what up?','what´s the dilly?','how goes it?','´sup?','konnichi wa','how´s it hanging?','what´s the rumpus?','hola','how´s it hanging?','how ya goin?','holla','whazzup?','hey','how goes it?','what´s cracking?','howzit?','wassap?','what´s the rumpus?','greetings','guten Tag','what´s the dizzle?','hello','good morning','what´s up?','good afternoon','ahoy','what´s crack-a-lackin´?','what´s cooking?','yo','what´s cooking?','What´s in the bag?','what´s new?','sup','good night','salutations','whazzup?','how ya goin?','what´s the haps?','hello','good night','what´s cracking?','good night','holla','hola','hey','´sup?','good evening','what´s poppin´?','sup','what´s up?','how ya goin?','what´s crack-a-lackin´?','yello','konnichi wa','what´s up?','good afternoon','what´s up?','hola','how goes it?','holla','good morning','greetings','aloha','aloha','hola','what´s the dizzle?','whazzup?','how goes it?','greetings','salutations','holla','how do?','greetings','wussup?','what´s crackin´?','yo','how´s it going?','wussup?','what´s the rumpus?','what´s the dilly?','wassap?','wassap?','holla','What´s in the bag?','what´s shaking?','what´s shaking?','wussup?','what´s crackin´?','hey','what´s the dizzle?','good day','wassap?','yello','good afternoon','konnichi wa','hey','what´s poppin´?','´sup, b?','what´s cooking?','what´s happening?','good night','aloha','what´s crack-a-lackin´?','what´s happening?','what´s crack-a-lackin´?','yo','what´s the rumpus?','how´s it hanging?','what´s the dizzle?','what´s up?','guten Tag','´sup, b?','how´s it hanging?','wussup?','yo','what´s crack-a-lackin´?','what´s cooking?','guten Tag','what´s the rumpus?','what´s shaking?','whazzup?','what ho?','what´s the dizzle?','good morning','hola','guten Tag','sup','good evening','what´s poppin´?','how´s it hanging?','holla','yo','what´s cooking?','what´s up?','´sup, b?','good night','salutations','greetings','What´s in the bag?','holla','yello','what ho?','´sup?','yello','salutations','what´s the rumpus?','yo','wussup?','konnichi wa','yo','what´s crack-a-lackin´?','what´s the dilly?','aloha','´sup, b?','ahoy','´sup, b?','konnichi wa','´sup, b?','what´s crackin´?','whazzup?','how ya goin?','whazzup?','what´s crackin´?','howzit?','what´s cracking?','what´s cooking?','how do?','how´s it hanging?','how´s it going?','what´s cracking?','good day','how goes it?','good night','yo','what´s cooking?','good day','how´s it hanging?','what ho?','´sup, b?','what´s crack-a-lackin´?','holla','how´s it hanging?','yo','whazzup?','greetings','how do?','how´s it going?','how´s it going?','salutations','hola','what´s cracking?','what´s the rumpus?','what´s new?','what´s the rumpus?','salutations','greetings','guten Tag','guten Tag','how´s it hanging?','how do?','what´s cracking?','´sup?','how ya goin?','what ho?','good afternoon','what´s shaking?','yello','wussup?','what´s up?','salutations','hey','what´s the dilly?','yo','what up?','how´s it going?','how´s it hanging?','aloha','what up?','sup','what ho?','what´s shaking?','ahoy','what ho?','good morning','whazzup?','good night','hello','good day','salutations','good morning','salutations','what´s up?','good night','what´s poppin´?','good night','good afternoon','guten Tag','guten Tag','what´s cooking?','good afternoon','what´s cracking?','good afternoon','wassap?','What´s in the bag?','what´s up?','what´s shaking?','holla','What´s in the bag?','what´s shaking?','what up?','how ya goin?','how goes it?','good evening',],
        timeAgo:  [ '2 minutes ago' , '5 minutes ago', '1 hour ago', '3 hours ago', '1 day ago', '2 days ago', '1 week ago', '2 weeks ago', '1 month'],
        phones: ['(487) 622-4286','1-371-864-3444','(831) 623-5468','(754) 204-3040','(636) 253-3661','1-886-932-2934','1-712-647-6617','(385) 557-2527','1-324-777-4518','(833) 764-4786','1-805-878-6285','(841) 993-3747','1-346-744-7515','1-527-728-1077','1-710-626-9255','1-193-268-1847','(268) 847-7980','(121) 511-2863','(111) 583-2583','(788) 610-5549','(884) 838-4035','1-714-531-4670','(413) 957-9569','(472) 485-2053','(252) 500-6631','1-216-740-8857','1-585-757-3344','1-463-768-6581','(978) 485-6718','1-608-203-9478','1-243-510-3724','(508) 638-5802','(424) 297-8152','1-611-716-1532','(488) 248-7137','(473) 860-3501','1-230-672-5658','1-126-346-4686','(895) 590-2078','(384) 794-2327','1-430-811-2132','1-708-907-1927','(236) 678-4234','1-712-406-4736','1-608-822-3892','(101) 206-0164'],
        messageStatus: ['','new','read'],
        messagesPending: ['1','2','3','4','5','6','7','8','9','10'],
        //mock data for user data from the system side (MIQ USER)
        currentUser: {userName: 'Todd', userLastName: 'Earwood', iqPhone: '(305)800-6437', email:'todd@integrateiq.com'},
        //mock data for selected user (not dinamically switching yet)
        currentChatInfo: { firstName: '', lastName: '', phone: '', email:'',initials:''},
        //Selector for Multi User Phones 
        ContactPhoneSelected: null,
        currentChattRecepientrPhoneList:[],
        chatEntries: [],
        
        //Conversations filter search pattern
        conversationFilter:"",

        //temp statuses for conversations filters 
        statusesFilter: ['View All', 'Bar', 'Fizz', 'Buzz'],
        hubspotStatusFilter: ['View All','FooHS', 'BarHS', 'FizzHS', 'BuzzHS'],
        //Selector for Bussiness Phone 
        BussinessPhoneSelected: "",
        BussinessPhones: [],
        window: { //store location when page will need vertical space calculations ()
            width: 0,
            height: 0
        },
        connection: {},
        companyId: null,
        contactId: null,
        objectType:null,
        userId:null,
        loading: true,
        isFavorite: false,
        unsubscribed: false,
        isConversation: true,
        sentNewContact: false
      }
    },
    created() {
        this.$auth.auth0ClientPromise.then(async () => {
            await this.setCompanyId();
            await this.updateHSHubspot();
            this.loading = false;
            this.getCompaniesPhones();
            this.getContactPhones();
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        });
    },
    mounted(){
        // Hide Intercom Launcher
        Intercom('update', {
            "hide_default_launcher": true
        });
         messageHub.client.on("Send",(message) => {
            this.handelIncommingMessage(message);
        });
        messageHub.start();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    computed: {
        ...mapGetters({
            currentCompanyPhone: 'company/getCurrentCompanyPhone',
            currentCompany: 'company/getCurrentCompany',
            currentSelectedContact:'contact/getCurrentSelectedContact',
            blockClicks: 'message/getBlockClicks'
        }),
    },
    
    watch: {
        isUpdating (val) {
            if (val) {
            setTimeout(() => (this.isUpdating = false), 3000)
            }
        },
        newMessage: function (newValue, oldValue) {
            this.snackbar = true;
        },
    },
    methods: {

        test(){
            
        },
        calcMargin(i) {
            return (i*70) + 'px'
        },
        genRandomIndex (length) {
            return Math.ceil(Math.random() * (length - 1))
        },
        uploadFile() {
            this.conversationDetail = !this.conversationDetail;
        },
        remove (item) {
            const i = this.friends.indexOf(item.name)
            if (i >= 0) this.friends.splice(i, 1)
        },
        
        setConvesationListVisibility( value) {
            this.conversationsList = value;
        },
        setConversationDetailVisibility( value) {
            this.conversationDetail = value;
        },
        async setCompanyId(){
            this.companyId = this.$route.query.c;
            this.contactId = this.$route.query.co;
            this.objectType = this.$route.query.o;
            this.userId = this.$route.query.u;
            await this.$store.dispatch('company/getCompanyByHubspotId',this.companyId);
        },
        async getCompaniesPhones() {
            let companies = await this.$store.dispatch('message/getAvailablePhones',{"hubspotPortalId": this.companyId, "hubspotUserId": this.userId});
            companies.map((company, index)  => {this.BussinessPhones.push({ value: company.phoneNumber, phoneIndex: (index + 1), alias: company.name, phone: company.phoneNumber})});
           if(this.BussinessPhones.length >= 1 ){
                this.setBussinessPhoneSelected(this.BussinessPhones[0].phone);
            }
        },
        async getContactPhones() {
           let contactsPhones = await this.$store.dispatch('message/getContactPhones', {"contactId": this.contactId, "companyId": this.companyId, "type": this.objectType});
            contactsPhones.map((contact, index)  => {
            let alias = "P";
            if(contact.isMobile === true){
                alias  = "M"
            }
            this.currentChattRecepientrPhoneList.push({value:(contact.fullName + " - "  + alias) ,phone: contact.phone,alias:(contact.fullName + " - "  + alias), fullName: contact.fullName, userPhoneIndex:(index + 1)})});
            if(this.currentChattRecepientrPhoneList.length == 1){
                this.setContactPhoneSelected(this.currentChattRecepientrPhoneList[0]);
            }
        },

        async loadMessages(){
          await this.getContactInfo();
          this.overlay = false;
          await this.getContactMessages();
        },

        setBussinessPhoneSelected(value) {
            this.BussinessPhoneSelected = value;
            this.$store.dispatch('company/setCurrentCompanyPhone',value);
            if (this.overlay == false){
                this.getContactMessages();
            }
        },

        setContactPhoneSelected(value) {
            this.ContactPhoneSelected = value;
            this.getContactInfo();
            this.$store.dispatch('contact/setCurrentContactPhone',value);
            if (this.overlay == false){
                this.getContactMessages();
            }
        },

        async getContactMessages() {
            this.isConversation = true;
            console.log("In function");
            console.log(this.currentSelectedContact);
            let contactMessages = await this.$store.dispatch('message/getContactMessages',{"contactId": this.currentSelectedContact, "companyPhone":  this.BussinessPhoneSelected}); 
            this.chatEntries = [];
            if(contactMessages != undefined){ 
                Object.keys(contactMessages).map(key => {
                    this.chatEntries.push({type: 'date',day: this.formatDay(contactMessages[key].item1)});
                    contactMessages[key].item2.map(message => {
                        let initials = '';
                        let hsMessage = '';
                        let direction = false;
                        let phoneInfo = '';
                        let hasIcon = true;
                        let icon = '';
                        if(message.direction === 'outbound-api'){
                            direction = true;
                            if (message.fromPhone !== ''){
                                var PhoneIndex = this.BussinessPhones.findIndex(x => x.phone == message.fromPhone);
                                if (PhoneIndex >= 0){
                                    if (this.BussinessPhones[PhoneIndex].alias !== ''){
                                        phoneInfo = this.BussinessPhones[PhoneIndex].alias + ' |';
                                    }
                                }
                            }

                            switch(message.sourceType){
                                case 'hubspot':
                                    hsMessage =message.smsMessageHubSpotData.hubSpotWorkflowName + ' | ';
                                    icon = '$hubspotIcon';
                                break;
                               case 'system':
                                    icon = '$miqIcon';
                                break;
                                case 'activecampaign':
                                    icon = '$activeCampaignIcon';
                                break;
                                default:
                                    initials = this.getInitials(this.currentCompany.name).slice(0, 2);
                                    hasIcon = false;
                                break;
                            }
                        }
                        var data ={}
                        if(message.mediaUrl !=null){
                            message.mediaType = 'media';
                        }
                        if(message.mediaType === 'video/3gpp'){
                            data = {type: 'media',  timeStamp:  this.formatHour(message.dateCreated), outbound: direction,   
                            mediaType:'video',   hsFlow:null, fromNumber:null,  mediaURL:message.mediaUrl,phoneInformation:phoneInfo,initials: initials, hubSpotWorkflowName:hsMessage, hasIcon:hasIcon,icon:icon,status:message.status};
                        }else{
                            data = {type: 'message',timeStamp: this.formatHour(message.dateCreated), outbound: direction,  hsFlow:null,status:message.status, 
                            fromNumber: message.fromPhone,  messageStatusID:"0", messageBody: message.body,phoneInformation:phoneInfo,initials: initials, hubSpotWorkflowName:hsMessage, hasIcon:hasIcon,icon:icon, mediaURL:message.mediaUrl};
                        }

                        this.chatEntries.push(data);
                    });
                });
                setTimeout(() => {
                    this.scrollToEnd();
                },400);
            }

        },

        handelIncommingMessage(incommingMessage){
            let companyPhone = "";
            if(typeof this.BussinessPhoneSelected != 'undefined'){
                 if(typeof this.BussinessPhoneSelected == 'object'){
                    companyPhone = this.BussinessPhoneSelected.phone;
                 }else{
                    companyPhone = this.BussinessPhoneSelected;
                 }
            }
            if(this.currentSelectedContact === incommingMessage.smsMessageContactData.contactId && this.lastProcessedMessage !== incommingMessage.id !== incommingMessage.id && incommingMessage.fromPhone === companyPhone){
                this.lastProcessedMessage = incommingMessage.id;
                let dates = this.chatEntries.filter(obj => {
                    return obj.type === "date"
                });
                let needsDate = true;
                if(dates.length > 0){
                    let latestDate = moment.utc(dates[dates.length - 1].day).local();
                    let messageDate = moment.utc(incommingMessage.dateCreated).local();
                    let dayDiff = messageDate.diff(latestDate,'days');
                    if(dayDiff === 0){
                        needsDate = false;
                    }
                }
                let dateEntry = {type: 'date',day: incommingMessage.dateCreated};
                
                if(needsDate){
                    this.chatEntries.push(dateEntry);
                }
                this.pushMessageToConversation(incommingMessage);
                setTimeout(() => {
                    this.chatWindowScroll();
                },200);
            }
            
        },

        pushMessageToConversation(incommingMessage){
            if(incommingMessage.mediaType === 'Image'){
                let messageEntry = {
                    type: 'message',
                    timeStamp: this.formatHour(incommingMessage.dateCreated), 
                    outbound: false,  
                    hsFlow:null, 
                    fromNumber: incommingMessage.fromPhone,  
                    messageStatusID:"0", 
                    messageBody: incommingMessage.body,
                    mediaURL:null
                };  

                  this.chatEntries.push(messageEntry);

            }else if(incommingMessage.mediaType === 'video/3gpp'){
                // TODO: Add Video Support
            }else{
                let messageEntry = {
                    type: 'media',
                    timeStamp: this.formatHour(incommingMessage.dateCreated), 
                    outbound: false,  
                    mediaType:'image',
                    hsFlow:null, 
                    fromNumber: incommingMessage.fromPhone,  
                    messageStatusID:"0", 
                    mediaURL:incommingMessage.mediaUrl
                };  
                this.chatEntries.push(messageEntry);
            }
        },

        async getHubspotURL(){
             let url = await this.$store.dispatch('contact/getCurrentHubspotURL',this.currentSelectedContact);
             if (url != undefined){
                 window.open(url, '_blank');
             }
        },

        async updateCurrentChatInfo(){

            await this.$store.dispatch('contact/updateChatInfo',{id:this.currentSelectedContact,firstname: this.currentChatInfo.firstName,
            lastname:this.currentChatInfo.lastName,phonenumber: this.currentChatInfo.phone, email:this.currentChatInfo.email});
            let fullname = '';

            if(this.currentChatInfo.lastName != null && this.currentChatInfo.lastName != '' && this.currentChatInfo.lastName != undefined && this.currentChatInfo.lastName != ' '){
                fullname = this.currentChatInfo.firstName + " " + this.currentChatInfo.lastName;
             }
             else
             {
                fullname = this.currentChatInfo.firstName;
             } 

            let initials = this.getConversationInitials(fullname);
            this.currentChatInfo.initials = initials;        
        },

        setFavorite(isFavorite) {
            this.isFavorite = isFavorite;
        },

        scrollToEnd() {   
            let container = this.$el.querySelector("#conversation-pane");
            container.scrollTop = container.scrollHeight;
        },
        async getContactInfo(){
            this.currentChatInfo = {firstName: '',lastName: '',phone: '',email: '',initials: ''};
            let contact = await this.$store.dispatch('contact/getContactByPhoneNumber',{"companyId": this.currentCompany.id, "phoneNumber": this.ContactPhoneSelected.phone, "setContact": false});
            if(contact === ""){
                if(!this.sentNewContact){
                    this.sentNewContact = true;
                    contact = await this.$store.dispatch('contact/createContactByHubSpotId',{"companyId": this.companyId, "contactId": this.contactId, "phoneNumber": this.ContactPhoneSelected.phone})
                    this.$store.dispatch('contact/setCurrentSelectedContact', contact.id);
                    this.isFavorite = contact.isFavorite;
                    this.unsubscribed = contact.isUnsubscribed;

                    let fullname = '';
                    if(contact.lastName != null && contact.lastName != '' && contact.lastName != undefined && contact.lastName != ' '){
                        fullname = contact.firstName + " " + contact.lastName;
                    }
                    else
                    {
                        fullname = contact.firstName;
                    }

                    let initials = this.getConversationInitials(fullname);

                    this.currentChatInfo = {firstName: contact.firstName,lastName: contact.lastName,phone: contact.phone,email: contact.email,initials:initials};
                }
            }else{
                this.$store.dispatch('contact/setCurrentSelectedContact', contact.id);
                this.isFavorite = contact.isFavorite;
                this.unsubscribed = contact.isUnsubscribed;

                let fullname = '';
                if(contact.lastName != null && contact.lastName != '' && contact.lastName != undefined && contact.lastName != ' '){
                    fullname = contact.firstName + " " + contact.lastName;
                }
                else
                {
                    fullname = contact.firstName;
                }

                let initials = this.getConversationInitials(fullname);

                this.currentChatInfo = {firstName: contact.firstName,lastName: contact.lastName,phone: contact.phone,email: contact.email,initials:initials};
            }
        },
        getConversationInitials(fullName){
            let initials = '';
            if(fullName != undefined && fullName != null){
                let name = fullName.trim().split(/\s+/).filter(part => part.length > 0);
                if(name.length > 1){
                    initials = name[0][0] + "" + name[1][0];
                }else if(name.length === 1){
                    initials = name[0][0];
                }
            }

            return initials;
        },

        async updateHSHubspot(){
            if(this.userId != null && this.userId != undefined){
                await this.$store.dispatch('company/updateHSUserId',{"hsUserId": this.userId});
            }
        }
    },
  }
</script>